<template>
  <v-card
    width="100%"
    height="100%"
    outlined
    :color="
      this.$vuetify.theme.dark
        ? 'primary darken-1 glcard gldark'
        : 'primary glcard'
    "
    rounded="xl"
    class="mb-4"
    :dark="this.$vuetify.theme.dark"
  >
    <v-card-title class="font-weight-black nwhite--text text--darken-2">
      <v-avatar
        v-if="food.date === new Date().toISOString().split('T')[0]"
        size="14"
        color="red"
        class="mr-2"
      />
      {{ food.humandate }}
    </v-card-title>
    <v-card-subtitle class="text-h5 font-weight-bold nwhite--text">
      {{ food.data }}
      <v-row no-gutters class="text-subtitle-1 font-italic">
        <v-col cols="12" class="text-h5 font-weight-bold nwhite--text">
          {{ food.kasvis }}
        </v-col>
        <v-col v-if="food.salaatti" cols="12">
          {{ food.salaatti }}
        </v-col>
        <v-col v-if="food.alkupera" cols="12">
          <p class="mt-2 mb-0">Alkuperä:</p>
          {{ food.alkupera }}
        </v-col>
      </v-row>
    </v-card-subtitle>

    <!-- <v-card-actions>
      <v-btn text rounded>Button</v-btn>
      <v-btn text rounded>Button</v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<style scoped>
.glcard {
  background: linear-gradient(
    180deg,
    rgba(88, 89, 112, 1) 0%,
    rgba(55, 57, 77, 1) 63%
  );
  box-shadow: 0 4px 14px 0 rgb(31 38 135 / 37%),
    0 -2px 10px 0px rgb(0 0 0 / 35%) inset;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 10px;
}
.glcard.gldark {
  box-shadow: 0 2px 7px 0 rgb(250 250 250 / 17%),
    0 -2px 7px 1px rgb(0 0 0 / 35%) inset;
}
</style>

<script>
export default {
  props: {
    food: {
      type: Object,
      required: true
    }
  }
};
</script>
